import { screenMd } from 'constants/styles/breakpoints';
import styled from 'styled-components';

export const Container = styled.section<{ lock?: boolean }>`
  width: 100%;
  /* Allow the chart column to shrink below its content width inside the
     counters/chart flex row, so the controls row stays within the viewport
     and right-aligns instead of overflowing off the right edge. */
  min-width: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  ${({ lock }) =>
    lock &&
    `
  opacity: 0.3;
  pointer-events:none;`}

  ${screenMd} {
    flex-direction: column;
  }
`;
